<template>
  <div class="notice-page">
    <div class="page-title">{{ $t('gong-gao-zhong-xin') }}</div>

    <div class="notice-list">
      <div class="list" v-for="(item, i) in noticeList" :key="i" @click="toDetail(item)">
        <div class="title">{{item.Title}}</div>
        <div class="time">{{item.CreatedAt}}</div>
        <div class="detail" v-html="item.Content"></div>
      </div>
    </div>
     <pageBar :total="page.total" @changePage="changePage"></pageBar>
  </div>
</template>
<script>
import pageBar from '@/components/pageBar'
import { getNoticeList } from '@/api/index'
export default {
  components: {
    pageBar
  },
  data() {
    return {
      page: {
        page: 1,
        limit: 10,
        total: 1
      },
      noticeList: [ ]
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      getNoticeList().then(res => {
        this.noticeList = res.data.Items
        this.page.total = res.data.Pagination.totalRecords
      })
    },
    back() {
      this.$router.go(-1)
    },
    readAll() {

    },
    toDetail(data) {
      sessionStorage.setItem('noticeDetail', JSON.stringify(data))
      this.$router.push({
        name: 'noticeDetail'
      })
    },
     changePage(page) {
      this.page.page = page
      this.init()
    }
  }
}
</script>